define('vspot-angular/services/nlytcs-service',[], function () {
    'use strict';

    return ['resources.Nlytcs', function (Nlytcs) {
        var notPartOfExperiment = -1;

        return {
            // constant so that caller can decide what to do for those that aren't in the experiment population
            notPartOfExperiment: notPartOfExperiment,
            /*
             *  Get the variation for a given user/experiment combination. If the experiment has
             *  a winner, that will be returned for everyone. If no winner and there was a previous variation for the user,
             *  that is returned. If no winner and no previous variation one is chosen based on the population_selector of
             *  the experiment (which is set by the experiment creator).
             *
             *  @param experimentId   [INT]    one of experiment_id or experiment_name is required
             *  @param experimentName [STRING] one of experiment_id or experiment_name is required
             *  @param userId         [INT]    0 for current logged in user
             */
            getVariation: function (experimentId, experimentName, userId) {
                var uId = userId || 0;

                return Nlytcs.getVariation({
                    user_id: uId,
                    experiment_id: experimentId,
                    experiment_name: experimentName
                });
            },

            /*
             *  Tracks an event on the client.
             *
             *  @param groupName     [STRING] [REQUIRED] (any string, can be used for the category like 'job edit')
             *  @param eventName     [STRING] [REQUIRED] (any string can be used for the action like 'clicked_share' or 'dialog_open')
             *  @param eventValue    [INT]    [OPTIONAL] A numeric value to associate with the event, such as number of shifts or length of time
             *  @param experimentId  [INT]    [OPTIONAL] 0 for none
             *  @param variation     [INT]    [OPTIONAL] Which variation of the experiment to track
             *  @param userId        [INT]    [OPTIONAL] 0 for current user (most common case)
             *
             *  @returns The id of the event.
             */
            trackEvent: function (groupName, eventName, eventValue, experimentId, variation, userId) {
                var expId = experimentId || 0,
                    uId = userId || 0;

                if (variation !== notPartOfExperiment) {
                    return Nlytcs.trackEvent({
                        userId: uId,
                        experiment_id: expId,
                        event_value: eventValue,
                        group_name: groupName,
                        event_name: eventName
                    });
                }
            },

            /*
             *  Tracks an event on the client with a time.
             *
             *  @param groupName     [STRING] [REQUIRED] (any string, can be used for the category like 'job edit')
             *  @param eventName     [STRING] [REQUIRED] (any string can be used for the action like 'clicked_share' or 'dialog_open')
             *  @param experimentId  [INT]    [OPTIONAL] 0 for none
             *  @param variation     [INT]    [OPTIONAL] Which variation of the experiment to track
             *  @param userId        [INT]    [OPTIONAL] 0 for current user (most common case)
             *
             *  @returns The id for the started event. Use for ending the event.
             */
            startEvent: function (groupName, eventName, experimentId, variation, userId) {
                var expId = experimentId || 0,
                    uId = userId || 0;

                if (variation !== notPartOfExperiment) {
                    return Nlytcs.startEvent({
                        user_id: uId,
                        experiment_id: expId,
                        group_name: groupName,
                        event_name: eventName
                    });
                }
            },

            /*
             *  Ends a started event and tracks the time.
             *
             *  @param eventId       [INT]    [REQUIRED] The id of the started event
             *  @param variation     [INT]    [OPTIONAL] Which variation of the experiment to track
             */
            endEvent: function (eventId, variation) {
                if (variation !== notPartOfExperiment) {
                    return Nlytcs.endEvent({
                        event_id: eventId
                    });
                }
            },

            /*
             *  Get all the experiments for a user.
             *
             *  @param userId [INT] [OPTIONAL] 0 for current user (most common case)
             */
            getexperiments: function (userId) {
                var uId = userId || 0;

                return Nlytcs.getExperiments({
                    user_id: uId
                });
            }
        };
    }];
});

